import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export interface TempSummary {
  returnAir1?: number;
  returnAir2?: number;
  returnAir3?: number;
  sensor1: number;
  sensor2: number;
  sensor3: number;
  tempMax: number;
  tempMin: number;
}

@Component({
  selector: 'ui-temp-pills',
  imports: [DecimalPipe],
  templateUrl: './temp-pills.component.html',
  styleUrls: ['./temp-pills.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TempPillsComponent {
  public readonly tempSummary = input<TempSummary>();
  public readonly sensorType = input<'returnAir' | 'sensor'>('sensor');

  protected sensorData = computed(() => {
    const summary = this.tempSummary();
    if (!summary) return undefined;

    if (this.sensorType() === 'sensor') {
      return generateSensorVM(
        { sensor1: summary.sensor1, sensor2: summary.sensor2, sensor3: summary.sensor3 },
        summary.tempMax,
        summary.tempMin,
        'S'
      );
    } else {
      return generateSensorVM(
        { sensor1: summary.returnAir1, sensor2: summary.returnAir2, sensor3: summary.returnAir3 },
        summary.tempMax,
        summary.tempMin,
        'RA'
      );
    }
  });
}

function generateSensorVM(
  sensors: { sensor1?: number; sensor2?: number; sensor3?: number },
  tempMax: number,
  tempMin: number,
  labelPrefix: string
): Sensors {
  return {
    sensor1: {
      label: `${labelPrefix}1`,
      value: sensors.sensor1,
      hasDeviation: sensors.sensor1 ? sensors.sensor1 > tempMax || sensors.sensor1 < tempMin : false
    },
    sensor2: {
      label: `${labelPrefix}2`,
      value: sensors.sensor2,
      hasDeviation: sensors.sensor2 ? sensors.sensor2 > tempMax || sensors.sensor2 < tempMin : false
    },
    sensor3: {
      label: `${labelPrefix}3`,
      value: sensors.sensor3,
      hasDeviation: sensors.sensor3 ? sensors.sensor3 > tempMax || sensors.sensor3 < tempMin : false
    }
  };
}

export interface Sensors {
  sensor1: { label: string; value?: number; hasDeviation: boolean };
  sensor2: { label: string; value?: number; hasDeviation: boolean };
  sensor3: { label: string; value?: number; hasDeviation: boolean };
}
